/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import BaseStep from './BaseStep';

/**
 * The ChartInsightsTask is inserted into the renderSequence whenever the feature is available.
 * Its purpose is to save enough information to execute a chart insights query (but not actually execute it).
 */
class ChartInsightsTask extends BaseStep {
	process(renderContext) {
		//TODO: || renderContext.data.getDefaultQueryResult can be removed when the isNewQueryApiEnabled flag is removed.
		if (renderContext && renderContext.data && (renderContext.data.getResult || renderContext.data.getDefaultQueryResult)) {
			this.chartInsightsFeature.setChartInsightsData(renderContext.data);
		}
		return Promise.resolve(renderContext);
	}
}

export default ChartInsightsTask;



// WEBPACK FOOTER //
// ./src/js/features/insights/rendersequence/ChartInsightsTask.js